import React from 'react';
import Modal from './Modal';
import { uploadAPI } from '../../InterfaceAPI/uploadAPI';

class ImageUploadModal extends React.Component {
  state = {
    submitLabel: 'Upload',
    disabled: false
  };

  render() {
    const { isOpen, closeModal, title, name } = this.props;
    const { submitLabel, disabled } = this.state;
    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 cms__section-head">{title}</h2>

        <form encType="multipart/form-data">
          <div className="form__row">
            <div className="form__row-item">
              <input type="file" id={name} name={name} className="input-file" />
              <p className="p p--dark-taupe p--em small">
                JPG, PNG or PDF only
              </p>
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="button"
                value={submitLabel}
                className="btn btn--solid-blue btn--full-width"
                onClick={this.uploadAction}
                disabled={disabled}
              />
            </div>
          </div>
        </form>
      </Modal>
    );
  }

  handleChange = text => {
    this.setState({ text });
  };

  uploadAction = () => {
    this.setState({ submitLabel: 'Uploading...', disabled: true });
    const data = new FormData();
    const imagedata = document.querySelector(`#${this.props.name}`).files[0];
    data.append('image', imagedata);

    uploadAPI
      .uploadImage(data)
      .then(image => {
        this.props.onSubmit(image);
        this.setState({
          submitLabel: this.props.submitLabel || 'Upload',
          disabled: false
        });
      })
      .catch(error => console.log(error));
  };

  deriveState() {
    return {
      submitLabel: this.props.submitLabel || 'Upload'
    };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props !== prevProps) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default ImageUploadModal;



// WEBPACK FOOTER //
// ./src/components/shared/ImageUploadModal.js